export default {
  header: {
    notes: 'Preferences dialog header',
    message: 'Preferences',
  },
  welcome: {
    notes: 'Welcome message in preference dialog',
    message: 'Hi {{firstName}} {{lastName}}, welcome to SAM!',
  },
  personalInfo: {
    notes: 'Page for personal information',
    message: 'Personal information',
    contact: {
      notes: 'Contact header',
      message: 'Contact',
    },
    password: {
      notes: 'Password header',
      message: 'Password',
    },
  },
  personalization: {
    notes: 'Page for personalization',
    message: 'Personalization',
    displayFormat: {
      notes: 'Display format section header',
      message: 'Display format',
      numbers: {
        notes: 'Label for number format preview row',
        message: 'Numbers',
      },
      dates: {
        notes: 'Label for date format preview row',
        message: 'Dates',
      },
      hint: {
        notes:
          'Explains that formatting follows browser language and how to change it. Chrome: Settings > Languages',
        message:
          'Formatting follows your browser language settings. To change it, update the language list in your browser (e.g. Chrome: Settings → Languages).',
      },
    },
    regionAndLocale: {
      notes: 'Region and locale header',
      message: 'Region & Locale',
      region: {
        notes: 'Region label',
        message: 'Region',
      },
      language: {
        notes: 'Language label',
        message: 'Language',
      },
      dateFormat: {
        notes: 'Date format label',
        message: 'Date format',
      },
      units: {
        notes: 'Unit label',
        message: 'Units',
      },
    },
    notifications: {
      notes: 'Notifications header',
      message: 'Notifications',
    },
    updatesAndImportantMessages: {
      notes: 'Updates and important messages header',
      message: 'Updates and important messages',
      receiveMessages: {
        notes: 'Receive important messages and updates about SAM',
        message: 'Receive important messages and updates about SAM',
      },
    },
  },
  dataAndSecurity: {
    notes: 'Page for data and security',
    message: 'Data & security',
    security: {
      notes: 'Security header',
      message: 'Security',
    },
  },
  agreements: {
    notes: 'Settings page for agreements',
    message: 'Agreements',
  },
};
